import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enUs from '@/locales/en-us'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en-us', // 设置语言环境
  messages: { // 设置语言环境信息
    'en-us': enUs
  }
})

const loadedLanguages = [] // 我们的预装默认语言

function setI18nLanguage (lang) {
  i18n.locale = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync (lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(/* webpackChunkName: "lang-[request]" */ `@/locales/${lang}.json`).then(msgs => {
        i18n.setLocaleMessage(lang, msgs.default)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      })
    }
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}

export default i18n
